import { render } from "./Menu.vue?vue&type=template&id=165a0dbc&scoped=true&ts=true"
import script from "./Menu.vue?vue&type=script&lang=ts"
export * from "./Menu.vue?vue&type=script&lang=ts"

import "./Menu.vue?vue&type=style&index=0&id=165a0dbc&scoped=true&lang=css"

import exportComponent from "/Users/andrea/Sites/app_v2/app_ambient/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-165a0dbc"]])

export default __exports__